import styled from "styled-components";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import Button from "@mui/material/Button";
import Badge from "@mui/material/Badge";

const WrapperButton = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
  padding: 0px;
  width: 200px;
  margin-left: ${({ mobile }) => (mobile ? "0" : "auto")};

  .Button-Add {
    color: ${({ color }) => color};
    width: 100%;
    background: ${({ backgrounColor }) => backgrounColor};
    border: 1px solid ${({ borderColor }) => borderColor};
    border-radius: 16px;
    height: 52px;
    padding: 0 16px;
  }
  .Button-Add:focus {
    background-color: ${({ backgrounColor }) => backgrounColor};
  }
  .Button-Add:hover {
    background-color: ${({ backgrounColor }) => backgrounColor};
    opacity: 0.9;
  }

  @media (max-width: 767px) {
    display: ${({ mobile }) => (mobile ? "flex" : "none")};
    width: 100%;

    .MuiBadge-root {
      font-size: 0.75rem;
      font-weight: 500;
    }
  }
`;

const FilterMobileButton = ({ onDialog = () => {}, dataSearch = {} }) => {
  return (
    <WrapperButton
      mobile
      backgrounColor="white"
      color="#e04132"
      borderColor="#D8D8DC"
    >
      <Button
        className="Button-Add"
        startIcon={<FilterAltOutlinedIcon />}
        onClick={() => onDialog()}
      >
        <Badge
          variant="dot"
          sx={{
            "& .MuiBadge-badge": {
              backgroundColor:
                (dataSearch?.date ||
                  dataSearch?.seller ||
                  dataSearch?.carrier ||
                  dataSearch?.failedReason) &&
                "#e04132",
              top: "5px",
              right: "-10px",
            },
          }}
        >
          ตัวกรอง
        </Badge>
      </Button>
    </WrapperButton>
  );
};

export default FilterMobileButton;
